<template>
  <v-form ref="cashiersForm">
    <v-text-field
      v-model="data.Nomb"
      :rules="rules.name"
      label="Nombre"
      outlined
      dense
      required
    ></v-text-field>

    <v-select
      v-model="data.Dptos"
      :rules="rules.department"
      :items="modulos"
      chips
      label="Departamento"
      multiple
      solo
      required
    ></v-select>

    <v-row>
      <v-col cols="2">
        <v-switch v-model="data.Actv" label="Activo"></v-switch>
      </v-col>
    </v-row>

    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</template>

<style scoped></style>

<script>
import { V } from "../../../helpers/ValidationRules";
export default {
  name: "CajerosForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      data: {
        Dpto: null,
        Actv: false,
        Dpts: null,
        Dptos: null,
        Nomb: null,
      },
      rules: {
        name: [
          V.required('El nombre es obligatorio'),
          V.minLength(2, 'El nombre debe tener al menos 2 caracteres'),
        ],
        department: [V.requiredSelect('El departamento es obligatorio')],
      },
    };
  },
  methods: {
    checkForm() {
      if (this.$refs.cashiersForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = this.$pgsHelper.cloneObj(this.data);
      const departments = {};
      dataSave.Dptos.forEach((department) => (departments[department] = true));
      dataSave.Dpts = departments;
      dataSave.Nomb = dataSave.Nomb.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
      if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.Id;
      }
      this.$emit("successData", dataSave, action);
    },
  },
  computed: {
    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
  },
  mounted() {
    this.data.Dpto = "ProShop"; //localStorage.getItem("selectedDepartment");

    if (this.edit) {
      const departments = [];
      Object.keys(this.dataEdit.Dpts).forEach((department) =>
        departments.push(department)
      );

      (this.data.Actv = this.dataEdit.Actv),
        (this.data.Dptos = departments),
        (this.data.Nomb = this.dataEdit.Nomb);
    }
  },
};
</script>
